exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modalEvidencia[data-v-4c3290c4],\n.modalEnvio[data-v-4c3290c4] {\n  position: fixed;\n  z-index: 1;\n  padding-top: 100px;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: #000;\n  background-color: rgba(0,0,0,0.4);\n}\n.modalEvidencia-content[data-v-4c3290c4],\n.modalEnvio-content[data-v-4c3290c4] {\n  background-color: #fafafa;\n  margin: auto;\n  padding: 20px;\n  border: 1px solid #888;\n  width: 80%;\n}\n.modalEnvio-content[data-v-4c3290c4] {\n  min-width: 300px;\n  max-width: 500px;\n  width: 30%;\n}\n", ""]);

// exports
